import React from 'react';
import PropTypes from 'prop-types';
import { useDroppable } from '@dnd-kit/core';
import './SignageEditor.css';

const Droppable = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  // Optionally we can highlight the container when hovered
  const style = {
    backgroundColor: isOver ? '#cceffd' : '',
    transition: 'background-color 0.2s ease',
  };

  return (
    <div className="editorMain" ref={setNodeRef} style={style}>
      {children}
    </div>
  );
};

Droppable.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Droppable;
